import type { PollCreateRequestOptionsItem } from './pollCreateRequestOptionsItem';

/**
 * 트윗 생성 시 투표 정보
 */
export interface PollCreateRequest {
  /**
   * 투표 기간 (분 단위, 예 5분 ~ 7일)
   * @minimum 5
   * @maximum 10080
   */
  durationMinutes: number;
  /**
   * 투표 선택지 목록 (최소 2개, 최대 4개)
   * @minItems 2
   * @maxItems 4
   */
  options: PollCreateRequestOptionsItem[];
}
